import React, { useRef, useState } from 'react';

import * as s from './VideoPlayer.module.scss';

import ReactPlayer from 'react-player/youtube';
import { useWindowSizeContext } from '../context/useWindowSizeContext';

interface LayoutProps {
  videoUrl: string;
}

export const VideoPlayer: React.FC<LayoutProps> = ({ videoUrl }) => {
  const windowSize = useWindowSizeContext();
  const [playing, setPlaying] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);

  const [soundOn, setSoundOn] = useState(false);

  //const [isPlaying, setIsPlaying] = useState(false);
  const [controlsVisible, setControlsVisible] = useState(true);

  const videoContainer = useRef<HTMLDivElement>(null);

  //const isVisible = useOnScreen(videoContainer);

  return (
    <div
      ref={videoContainer}
      id="FullWidthRatioVideoPlayer"
      className={`${s.XPvideoPlayer}`}
    >
      <div className={`${s.videoResponsive}`}>
        <ReactPlayer
          url={videoUrl ?? ''}
          width="100%"
          height="100%"
          muted={soundOn}
          playing={playing}
          loop
          playsinline
          onEnded={() => {
            //  if (
            //    swiper?.slides?.length &&
            //    swiper?.activeIndex === swiper?.slides?.length - 1
            //  )
            //    swiper?.slidePrev();
            //  else swiper?.slideNext();
          }}
          className={s.reactPlayer}
          config={{
            playerVars: {
              cc_load_policy: 1,
              showinfo: 0,
              controls: 1,
              autoplay: 0,
              loop: 0,
              modestbranding: 1,
              disablekb: 1,
            },
          }}
          type="video/mp4"
        />
      </div>
    </div>
  );
};
